import React, { useEffect, useState } from 'react';
import './index.less';
import {
    ArrowLeftSvgComponent,
    SoilProfileSelectedActionIcon,
    SoilProfileStateClear,
    UserManagementIcon,
    SoilAnalysesCount,
    SoilProfileWarningAlertIcon,
    SoilCloseIcon
} from '../../resource/IconComponentSets';
import IF from '../IF';
import SoilButton from '../SoilButton';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../redux';
import {
    deleteAnalysis,
    soilProfileDeleteTargetProfile,
    soilProfileDownloadProfile,DLAnalyses,
    DownloadTemplate
} from '../../util/Request';
import { deleteUsers, downloadUserList, DeleteTemplate } from '../../util/Request';
//Echo
import {
    List,
    Modal,
    notification,
    Spin
} from 'antd';
import {
    ExclamationCircleOutlined,
} from '@ant-design/icons';
import { updateProfileSelectedList, updateSuccessMessage, updateWarningMessage } from '../../redux/reducer/common';
import moment from 'moment';

const { confirm } = Modal;

interface IProps {
    className?: string
    selectedCount?: number | string
    type?: 'QUERY' | 'PROFILE' | 'ANALYSES' | 'TEMPLATE'
    | 'REFERENCE' | 'MANAGEMENT' | 'SOILHISTORY'
    // downloadCallback?: () => void
    // deleteCallback?: () => void
    // closePanelCallback?: () => void
//   Management Properties
    rowsLength?: string
}
export default function SoilOperationPanel(props: IProps = {
    className: '',
    selectedCount: '0',
}) {
    const dispatch = useDispatch();
    const soilProfilesList = useSelector((state: RootState) => state.soilPageData.soilProfilesList);
    const { deleteFiled, visible, downloadList, profileSelectedList } = useSelector((state: RootState) => state.commonData);
    const { downloadUserLists} = useSelector((state: RootState) => state.userManagemnetPageData);
    const userInfo = useSelector((state: RootState) => state.soilUser.userInfo);
    const [deleteProfileModalVisible, setDeleteProfileModalVisible] = useState(false);
    const [spining, setSpining] = useState(false);
    const {
        className,
        selectedCount,
        // downloadCallback,
        // deleteCallback,
        // closePanelCallback,
        type,
        // Management Properties
        rowsLength
    } = props;

    const [textDes, setTextDes] = useState('');
    const downloadCallback = async ()=>{
        console.log(type);
        if(type == 'TEMPLATE'){
            console.log(downloadList);
            if(downloadList.length>1){
                // notification.open({
                //     duration: 3,
                //     message: 'Templates can only be downloaded individually！',
                //     icon: <WarningOutlined style={{ color: '#E99921' }} />
                // });
                dispatch(updateWarningMessage('Templates can only be downloaded individually!'));
            }
            if(downloadList.length==1){
                const date = moment().format('DD-MMM-YYYY');
                const userFileName= 'TEMPLATE' + '_' + date + '_' +parseInt(String(Math.random() * 1000000)) + '.' + 'xlsx';

                try {
                    dispatch({type:'common/updateShowLoading',payload:true});
                    await DownloadTemplate(
                        {
                            fileName: userFileName,
                            enumFileType: 'XLSX',
                            templateId:downloadList[0].quer_queryid,
                        }
                    );
                    dispatch({
                        type: 'common/deleteFile'
                    });
                    dispatch({type:'common/updateShowLoading',payload:false});
                } catch (error) {
                    dispatch({type:'common/updateShowLoading',payload:false});
                }
            }
        }
        if(type == 'ANALYSES'){
            console.log(downloadList);
            const arr:any = [],arr2:any = [];
            downloadList.map(e=>{
                arr.push(e.id);
                arr2.push(e.profileCode);
            });
            const date = moment().format('DD-MMM-YYYY');
            const userFileName= 'ANALYSES' + '_' + date + '_' +parseInt(String(Math.random() * 1000000)) + '.' + 'xlsx';

            try {
                dispatch({type:'common/updateShowLoading',payload:true});
                const res = await DLAnalyses(arr2.join(','),userFileName,'XLSX',arr,userFileName);
                dispatch({
                    type: 'common/deleteFile'
                });
                dispatch({type:'common/updateShowLoading',payload:false});
            } catch (error) {
                dispatch({type:'common/updateShowLoading',payload:false});
            }
        }
        try {
            if (type === 'PROFILE') {
                const profileIds = profileSelectedList.map((item) => item.id);
                const date = moment().format('DD-MMM-YYYY');
                return await soilProfileDownloadProfile({
                    listProfilesIDs: profileIds,
                    enumFileType: 'XLS',
                    fileName: `PROFILE_${date}_${parseInt(String(Math.random() * 1000000))}.xls`
                });
            }
        } catch(err) {
            console.log('err', err);
        }
        if (type == 'MANAGEMENT') {
            console.log('downloadUserListsdownloadUserLists', downloadList);
            const arr = [];
            downloadList.forEach(obj => {
                arr.push(obj.userId);
            });
            const date = moment().format('DD-MMM-YYYY');
            const userFileName= 'USER_MANAGEMENT' + '_' + date + '_' +parseInt(String(Math.random() * 1000000)) + '.' + 'xlsx';

            try {
                dispatch({type:'common/updateShowLoading',payload:true});
                await downloadUserList(userFileName,'XLSX',arr.join(','));
                dispatch({
                    type: 'common/deleteFile'
                });
                dispatch({type:'common/updateShowLoading',payload:false});
            } catch (error) {
                dispatch({type:'common/updateShowLoading',payload:false});
            }
        }
    };
    const deleteCallback = async () => {
        console.log(type);
        if (type == 'ANALYSES') {
            console.log('ANALYSES  delete',downloadList);
            // delete
            const arr = [];
            let bar = false;
            downloadList.map(obj => {
                arr.push(obj.id);
                if(obj.status!='Draft'){
                    bar = true;
                }
            });
            if(bar){
                // notification.open({
                //     duration: 3,
                //     message: '"Sample(s) " are in Finalised/Published/Obsolete status and hence can not delete these sample(s)";',
                //     icon: <WarningOutlined style={{ color: '#E99921' }} />
                // });
                dispatch(updateWarningMessage('Sample(s) " are in Finalised/Published/Obsolete status and hence can not delete these sample(s)'));

            }else{
                try {
                    dispatch({type:'common/updateShowLoading',payload:true});
                    const res = await deleteAnalysis({strAnalysesIDs:arr.join(',')});
                    dispatch({type:'common/updateShowLoading',payload:false});
                    dispatch({
                        type: 'common/deleteFile'
                    });
                    console.log('lanxue delete result',res);
                    if(res?.message === 'True' || res?.message === 'true'){
                        dispatch(updateWarningMessage('Soil Analyses have been deleted'));
                    }
                    else{
                        dispatch(updateWarningMessage('Delete Sample(s) failed!'));
                    }
                    dispatch({type:'common/updateShowLoading',payload:false});
                } catch (error) {
                    dispatch({type:'common/updateShowLoading',payload:false});
                    // notification.open({
                    //     duration: 3,
                    //     message: 'Delete Sample(s) failed！',
                    //     icon: <WarningOutlined style={{ color: '#E99921' }} />
                    // });
                    dispatch(updateWarningMessage('Delete Sample(s) failed!'));
                }
            }
        }
        if(type == 'TEMPLATE'){
            console.log('TEMPLATE  delete',downloadList);
            // delete
            const arr = [];
            downloadList.map(obj => {
                arr.push(obj.quer_queryid);
            });
            try {
                dispatch({type:'common/updateShowLoading',payload:true});
                const res = await DeleteTemplate({strTemplateId:arr.join('^')});
                dispatch({type:'common/updateShowLoading',payload:false});
                dispatch({
                    type: 'common/deleteFile'
                });
                // notification.open({
                //     duration: 3,
                //     message: 'Templates have been deleted',
                //     icon: <WarningOutlined style={{ color: '#E99921' }} />
                // });
                dispatch(updateWarningMessage('Templates have been deleted'));
            } catch (error) {
                dispatch({type:'common/updateShowLoading',payload:false});
                // notification.open({
                //     duration: 3,
                //     message: 'Delete Templates failed！',
                //     icon: <WarningOutlined style={{ color: '#E99921' }} />
                // });
                dispatch(updateWarningMessage('Delete Templates failed!'));

            }
        }
        if (type == 'MANAGEMENT') {
            confirm({
                title: 'Warning',
                icon: <ExclamationCircleOutlined />,
                content: 'You are about to remove selected user from the CE Hub.',
                async onOk() {
                    console.log('OK');
                    console.log('USER MANAGEMENT delete', downloadList);
                    // delete
                    const arr = [];
                    downloadList.forEach(obj => {
                        arr.push(obj.userId);
                    });
                    try {
                        dispatch({type:'common/updateShowLoading',payload:true});
                        const res = await deleteUsers({ selectedUserIDs: arr.join(',') });
                        dispatch({type:'common/updateShowLoading',payload:false});
                        dispatch({
                            type: 'userManagement/deleteFile'
                        });
                        dispatch({
                            type: 'common/deleteFile'
                        });
                        // notification.open({
                        //     duration: 3,
                        //     message: 'operation successful！',
                        //     icon: <CheckCircleOutlined style={{ color: '#19A04B' }} />
                        // });
                        dispatch(updateSuccessMessage('Operation successful!'));
                    } catch (error) {
                        dispatch({type:'common/updateShowLoading',payload:false});
                        // notification.open({
                        //     duration: 3,
                        //     message: 'operation failed！',
                        //     icon: <WarningOutlined style={{ color: '#E99921' }} />
                        // });
                        dispatch(updateWarningMessage('operation failed!'));
                    }
                },
                onCancel() {
                    console.log('Cancel');
                },
            });
        }
        // under profile page action
        if (type === 'PROFILE') {
            setDeleteProfileModalVisible(true);
        }
    };

    const confirmRemove = async () => {
        try {
            const idsArr = profileSelectedList.map((item) => item.id);
            const ids = idsArr.join(',');
            setSpining(true);
            const result = await soilProfileDeleteTargetProfile(ids);
            // if (result?.data?.message === 'True' || ) {
            //     setSpining(false);
            //     dispatch(updateProfileSelectedList([]));
            //     setDeleteProfileModalVisible(false);
            //     dispatch(updateSuccessMessage('Delete profile suceess!!'));
            // } else {
            //     console.log('need login');
            //     setSpining(false);
            // }
            // if (result && (result?.message === 'True' || result?.message === 'true')) {
            //     setSpining(false);
            //     dispatch(updateProfileSelectedList([]));
            //     setDeleteProfileModalVisible(false);
            //     dispatch(updateSuccessMessage('Delete profile suceess!!'));
            if (result && (result?.message === 'True' || result?.message === 'true')) {
                setSpining(false);
                dispatch(updateProfileSelectedList([]));
                setDeleteProfileModalVisible(false);
                dispatch(updateSuccessMessage('Delete profile suceess!!'));
            } else {
                console.log('need login');
                setSpining(false);
            }
        } catch (err) {
            setSpining(false);
        }
    };

    const closePanelCallback = ()=>{
        dispatch({
            type: 'common/closeDownFile'
        });
    };

    useEffect(() => {
        switch(type) {
            case 'PROFILE': {
                setTextDes('select profiles for actions');
                break;
            }
            case 'MANAGEMENT': {
                setTextDes('select Users for actions');
                break;
            }
            case 'ANALYSES': {
                setTextDes('select Analysis for actions');
                break;
            }
            case 'TEMPLATE': {
                setTextDes('Select Templates for actions');
                break;
            }
        }
    }, [type]);

    return (
        <IF show={visible}>
            <div className={`soil-operation-div  ${className}`}>
                <Modal
                    className='soil-profile-delete-confirm-mmoal'
                    open={deleteProfileModalVisible}
                    onCancel={() => setDeleteProfileModalVisible(false)}
                    onOk={() => setDeleteProfileModalVisible(false)}
                    width={950}
                    title={
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <SoilProfileWarningAlertIcon style={{ marginRight: '20px' }} />You are about to delete
                        </div>
                    }
                    footer={
                        <div className='footer-div'>
                            <button onClick={() => setDeleteProfileModalVisible(false)}>
                                Cancel
                            </button>
                            <button onClick={() => confirmRemove()}>
                                Delete
                            </button>
                        </div>
                    }
                    closeIcon={<SoilCloseIcon />}
                >
                    <Spin spinning={spining}>
                        <span className='notiice-header-span'>Soil profiles that will be deleted</span>
                        <div className='soil-profile-delete-confirm-title-div'>
                            <div>
                                <span>ID,Type</span>
                            </div>
                            <div>
                                <span>Name</span>
                            </div>
                            <div>
                                <span>Location</span>
                            </div>
                        </div>
                        <List
                            className='soil-profile-delete-list'
                            dataSource={profileSelectedList}
                            renderItem={(item) => (
                                <div className='delete-confirm-div'>
                                    <div className='first-delete-confirm-div'>
                                        <span className='first-span'>{item.fiTyName}</span>
                                        <span className='second-span'>{item.code}</span>
                                    </div>
                                    <div className='sub-item'>
                                        {item.name}
                                    </div>
                                    <div className='sub-item'>
                                        {item.adminName}
                                    </div>
                                </div>
                            )}
                        />
                    </Spin>
                </Modal>
                <div className='soil-operation-container' >
                    <div>
                        <IF show={type === 'ANALYSES'}>
                            <SoilAnalysesCount />
                        </IF>
                        <IF show={type === 'PROFILE'}>
                            <SoilProfileSelectedActionIcon />
                        </IF>
                        <IF show={type === 'MANAGEMENT'||type === 'TEMPLATE'}>
                            <UserManagementIcon />
                        </IF>
                        <span className='soil-operation-left-span'>
                            {type === 'PROFILE' ? `${profileSelectedList && profileSelectedList.length || '0'} ${textDes}` : `${downloadList.length} ${textDes}`}
                        </span>
                    </div>
                    <div className='soil-operation-right-div'>
                        <SoilButton
                            onClick={() => downloadCallback()}
                            highLight='default'
                            type='hover'
                        >
                            Download
                        </SoilButton>
                        <IF show={type === 'PROFILE' && userInfo && userInfo.roleName !== 'Reader' }>
                            <SoilButton
                                highLight='red'
                                type='hover'
                                onClick={() => deleteCallback()}
                            >
                                Delete Profiles
                            </SoilButton>
                        </IF>
                        <IF show={type === 'MANAGEMENT'}>
                            <SoilButton
                                highLight='red'
                                type='hover'
                                onClick={() => deleteCallback()}
                            >
                                Delete Users
                            </SoilButton>
                        </IF>
                        <IF show={type === 'ANALYSES'}>
                            <SoilButton
                                highLight='red'
                                type='hover'
                                onClick={() => deleteCallback()}
                            >
                                Delete Analyses
                            </SoilButton>
                        </IF>
                        <IF show={type === 'TEMPLATE'}>
                            <SoilButton
                                highLight='red'
                                type='hover'
                                onClick={() => deleteCallback()}
                            >
                                Delete Templates
                            </SoilButton>
                        </IF>
                        <button
                            className='soil-operation-close-button'
                            onClick={() => closePanelCallback()}
                        >
                            <SoilProfileStateClear />
                        </button>
                    </div>
                </div>
            </div>
        </IF>
    );
}
